import React, { useState, useEffect } from 'react';
import moment from 'moment';
import {
  Input,
  Balloon,
  Button,
  Radio,
  Loading,
} from '@alifd/next';
import { CanvasService } from '@/service';
import LzMsg from '@/components/common/LzMsg';
import SelectGoods from '@/components/SelectGoods';
import TopTitle from '@/components/UI/TopTitle';
import styles from './index.module.scss';

const venderType = JSON.parse(localStorage.getItem('LZ_CURRENT_SHOP'))?.venderType; // 判断当前店铺是品牌会员还是店铺会员 1-店铺（开卡） 0-品牌
// 报表模式tab选项
const reportType = [
  {
    name: '汇总',
    key: 2,
    label: 2,
  },
  {
    name: '触达',
    key: 0,
    label: 0,
  },
  {
    name: '点击',
    key: 1,
    label: 1,
  },
];
// 报表时间tab选项
const reportTime = [
  {
    name: '近1天',
    key: 1,
    label: 'one',
  },
  {
    name: '近3天',
    key: 3,
    label: 'three',
  },
  {
    name: '近5天',
    key: 5,
    label: 'five',
  },
  {
    name: '近7天',
    key: 7,
    label: 'seven',
  },
];

// 短信数据 数据项
/**
 *  isShow 判断  开卡会员 和 品牌会员 时
 */
const messageData = [
  { name: '点击次数', key: 1, isShow: true },
  { name: '点击人数', key: 2, isShow: true },
  { name: '加购人数', key: 3, isShow: true },
  { name: '商品详情页PV', key: 4, isShow: true },
  { name: '商品详情页UV', key: 5, isShow: true },
  { name: '店铺首页PV', key: 6, isShow: true },
  { name: '店铺首页UV', key: 7, isShow: true },
  { name: '收藏商品人数', key: 8, isShow: true },
  { name: '收藏店铺人数', key: 9, isShow: true },
  { name: '下单人数', key: 10, isShow: true },
  { name: '下单金额', key: 11, isShow: true },
  { name: '下单订单数', key: 12, isShow: true },
  { name: '下单件数', key: 13, isShow: true },
  { name: '付款人数', key: 14, isShow: true },
  { name: '付款金额', key: 15, isShow: true },
  { name: '付款订单数', key: 16, isShow: true },
  { name: '付款件数', key: 17, isShow: true },
  { name: '会员下单用户数', key: 18, isShow: true },
  { name: '会员下单新用户数', key: 19, isShow: true },
  { name: 'CVR', key: 20, isShow: true },
  { name: 'CTR', key: 21, isShow: true },
  { name: 'ROI', key: 22, isShow: true },
];
// 判断 1 是品牌会员 将其数据项 isShow置为true
if (Number(venderType) === 1) {
  messageData[17].isShow = true;
  messageData[19].isShow = true;
} else {
  // 0 是 店铺
  messageData[18].isShow = true;
  messageData[20].isShow = true;
}
// 过滤消息短信数据
const messageDataFilter = messageData.filter((i, index) => {
  return i.isShow === true;
});
// 商品数据 数据项
const goodsData = [
  { name: '浏览PV', key: 1 },
  { name: '浏览UV', key: 2 },
  { name: '加购件数', key: 3 },
  { name: '加购用户数', key: 4 },
  { name: '付款件数', key: 5 },
  { name: '付款用户数', key: 6 },
  { name: '付款金额', key: 7 },
];

export default ({
  activityInfo = {},
  visible = {},
  initData = {},
  runState = {},
  taskInstId = [],
  isPromotion = [],
  showProduct = true,
  onExportVisible = () => {},
  changeData = (data) => {},
  onCancel = () => {},
}) => {
  // // sku商品相关数据定义
  const RadioGroup = Radio.Group;
  // /**
  //  *    商品sku
  //  *
  //  */
  // 选择商品单选框
  const [goodsSelect, setGoodsSelect] = useState(1);
  // 添加商品弹窗
  const [goodsDialog, setGoodsDialog] = useState(false);
  // 选中的skuid
  const [skuIds, setSkuIds] = useState([]);
  // 选中的商品
  const [selectGoods, setSelectGoods] = useState([]);
  // loading
  const [isLoading, setIsLoading] = useState(false);
  /**
   *   数据导出
   */
  // Tab展示 0：详情，1：任务 3：报表
  const [showTabkey, setShowTabkey] = useState('0');
  // 报表营销类型tab
  const [isActiveType, setActiveType] = useState(2);
  // 报表营销完成时间tab
  const [isActiveTime, setActiveTime] = useState(3);

  // 报表面板数据
  const [reportPane, setReportPane] = useState({
    ordPins: 0,
    payAmount: 0,
    payPins: 0,
    roi: 0,
  });
  const { Tooltip } = Balloon;
  // 导出报表数据的接口，需要的参数
  // 时间维度
  const [timeAll, setTimeAll] = useState(false);
  const [days, setDays] = useState(1);
  const [customize, setCustomize] = useState(false);
  const [customizeObj, setCustomizeObj] = useState({
    customizeStart: '',
    customizeEnd: '',
  });
  // 数据维度
  const [typeAll, setTypeAll] = useState(false);
  const [types, setTypes] = useState(2);

  // 数据项
  // 短信数据
  const [fields, setFields] = useState([]); // 数据项英文
  const [head, setHead] = useState([]); // 数据项中文
  // 商品数据
  const [skuHead, setSkuHead] = useState([]); // 商品信息中文
  const [skuFields, setSkuFields] = useState([]); // 商品信息英文

  // 节点运行时详情数据
  const [state, setState] = useState({
    ...runState,
  });

  /**
   * 报表导出，时间维度的自定义天数
   * @param type-时间类型 customizeStart-开始时间，customizeEnd-结束时间
   */
  const customizeChange = (val, type) => {
    const obj = { ...customizeObj };
    // 处理成合法字符串
    val = val.replace(/[^\.\d]/g, '');
    val = val.replace('.', '');
    obj[type] = val;
    // 天数范围要保证在30天以内
    if (parseInt(val) === 0) {
      obj[type] = 1;
      setCustomizeObj({
        ...customizeObj,
        ...obj,
      });
    } else if (parseInt(val) > 30) {
      obj[type] = 30;
      setCustomizeObj({
        ...customizeObj,
        ...obj,
      });
    } else {
      obj[type] = val;
      setCustomizeObj({
        ...customizeObj,
        ...obj,
      });
    }
  };

  // 校验结束时间是否小于开始时间
  const compareCustomize = () => {
    if (
      parseInt(customizeObj.customizeEnd) <
      parseInt(customizeObj.customizeStart)
    ) {
      LzMsg.error('后一天的数须大于或等于前一天的数');
      setCustomizeObj({
        customizeStart: '',
        customizeEnd: '',
      });
    }
  };

  /**
   * 导出报表
   */
  const exportList = () => {
    if (customize) {
      if (!customizeObj.customizeStart || !customizeObj.customizeEnd) {
        LzMsg.error('请输入自定义的时间维度');
        return;
      } else if (customizeObj.customizeStart > customizeObj.customizeEnd) {
        LzMsg.error('请设置正确的自定义的时间维度');
        return;
      }
    }
    // 选择 自定义选择商品但是商品skuid列表为空
    if (goodsSelect === 2 && skuIds.length < 1) {
      // 回到顶部
      parent.scrollTo(0, 0);
      document.documentElement.scrollTop = 0;
      LzMsg.error('请先选择自定义选择商品');
      return;
    }
    let taskInstIdList = [];
    taskInstId.forEach((data)=>{
      taskInstIdList = taskInstIdList.concat(data.taskInstId.split(','))
    })

    const param = {
      taskInstIds: taskInstIdList,
      day:days, // 时间维度
      dimension: types, // 数据维度
      customDayStart: customize ? customizeObj.customizeStart : 0, // 自定义事件左
      customDayEnd: customize ? customizeObj.customizeEnd : 0, // 自定义事件右
      skuIds: skuIds.length > 0 ? skuIds.toString() : null, // 字符串
    };
    console.log(param,'参数');
    CanvasService.goodsDataExport(param)
      .then((res) => {
        // 关闭弹窗
        onExportVisible(false);
        // 回到顶部
        parent.scrollTo(0, 0);
        document.documentElement.scrollTop = 0;
        if (res.success) {
          LzMsg.success('数据导出成功');
        }
      })
      .catch(() => {
        parent.scrollTo(0, 0);
        document.documentElement.scrollTop = 0;
      });
  };

  /**
   * 清空所有下载选框的选择
   */
  const clearForm = () => {
    // 时间维度
    setTimeAll(false);
    setDays(1);
    setCustomize(false);
    // 自定义是时间
    setCustomizeObj({
      customizeStart: null,
      customizeEnd: null,
    });

    // 数据维度
    setTypeAll(false);
    setTypes(2);
    // 数据项
    // 关闭弹窗
    onExportVisible(false);
  };

  /**
   * 查询报表数据-面板数据
   * @param v.flag-左侧不同维度切换
   * @param v.time-右侧时间切换
   */
  const getSMSSummaryEffect = (v) => {
    const startTime =
      new Date(moment(state.activityInfo?.startTime).format('YYYY-MM-DD')) || 0;
    startTime.setHours(0); // 设置小时
    startTime.setMinutes(0); // 设置分钟
    startTime.setSeconds(0); // 设置秒
    startTime.setMilliseconds(0);
    const startT = startTime.getTime();
    const params = {
      flag: v.flag,
      startTime: startT,
      endTime: startT + 86400000 * (v.time - 1),
      taskInstId: state.activityInfo.jobId,
    };
    CanvasService.getSMSSummaryEffect(params)
      .then((res) => {
        setReportPane(res.data);
      })
      .catch((e) => {
        parent.scrollTo(0, 0);
        console.log(e);
        document.documentElement.scrollTop = 0;
      });
  };

  useEffect(() => {
    const startTime =
      new Date(moment(state.activityInfo?.startTime).format('YYYY-MM-DD')) || 0;
    startTime.setHours(0); // 设置小时
    startTime.setMinutes(0); // 设置分钟
    startTime.setSeconds(0); // 设置秒
    startTime.setMilliseconds(0);
    const startT = startTime.getTime();
    if (
      showTabkey === '2' &&
      state.activityInfo &&
      state.activityInfo.startTime
    ) {
      getSMSSummaryEffect({ flag: isActiveType, time: isActiveTime });
    }
  }, [showTabkey]);

  return (
    <div
      className={`${styles.detailRoot} ${styles.sendMessageRoot} ${styles['export-dialog']}`}
    >
      <div
        className={`${styles['export-report']} export-dialog`}
        style={{
          width: '100%',
        }}
      >
        <div style={{ margin: 30 }}>
          <TopTitle title='导出数据维度选择'/>
          {/* 导出时间维度选择 */}
          <div className={`${styles['display-flex']} times-item`}>
            <div style={{ width: '100%' }}>
              <div style={{ width: '100%' }} className={styles.ballon}>
                导出时间维度选择:
                <Tooltip
                  align="t"
                  alignEdge
                  closable={false}
                  style={{ color: '#9ca7b6', paddingLeft: '5px' }}
                  trigger={<span className="iconfont icon-icon4-33" />}
                >
                  <span>以发送时间起始，可导出30日内的效果数据。</span>
                </Tooltip>
              </div>
            </div>
            <div style={{ width: '100%', display: 'flex' }}>
              <div style={{ width: '35%', display: 'flex' }}>
                <RadioGroup
                  value={days}
                  onChange={(days) => {
                    setDays(days);
                    setCustomize(false)
                  }}
                  className={styles.timeCheck}
                >
                  {reportTime.map((i, index) => (
                    <Radio  style={{}} key={i.key} value={i.key}>
                      {i.name}
                    </Radio>
                  ))}
                </RadioGroup>
              </div>
              <Radio
                checked={customize}
                onChange={() => {
                  setCustomize(true);
                  setDays(0)
                }}
              >
                自定义 (不支持商品数据) :
              </Radio>
              <Input
                style={{ width: '8%', marginLeft: '15px' }}
                disabled={!customize}
                value={customizeObj.customizeStart}
                onChange={(val) => customizeChange(val, 'customizeStart')}
                onBlur={() => compareCustomize}
              />
              <span style={{ marginLeft: '15px' }}>天~</span>
              <Input
                style={{ width: '8%', marginLeft: '15px' }}
                disabled={!customize}
                value={customizeObj.customizeEnd}
                onChange={(val) => customizeChange(val, 'customizeEnd')}
                onBlur={() => compareCustomize}
              />
              <span style={{ marginLeft: '15px' }}>天</span>
            </div>
          </div>
          {/* 导出数据维度选择: */}
          <div
            className={`${styles['display-flex']}`}
            style={{ paddingBottom: '20px' }}
          >
            <div className={`${styles['inline-block-item']}`}>
              <span>导出数据维度选择: </span>
            </div>
            <div style={{ width: '100%', display: 'flex' }}>
              <div style={{ width: '35%', display: 'flex' }}>
                <RadioGroup
                  value={types}
                  onChange={(types) => {
                    setTypes(types)
                  }}
                  style={{ width: '100%' }}
                >
                  {reportType.map((i, index) => (
                    <Radio
                      style={{ width: '23%' }}
                      key={i.key}
                      value={i.label}
                    >
                      {i.name}
                    </Radio>
                  ))}
                </RadioGroup>
              </div>
            </div>
          </div>
          {/* 商品数据标题 */}
          {showProduct && <div
            style={{
              paddingBottom: '10px',
              marginTop: '30px',
            }}
          >
            <TopTitle title='商品数据'/>
          </div>}
          {/* 导出商品数据项选择 */}
          {showProduct && <div
            className={`${styles['display-flex']} options-item`}
            style={{ alignItems: 'flex-start', paddingBottom: '20px' }}
          >
            <div className={`${styles['inline-block-item']}`}>
              <span>导出商品选择 </span>
            </div>
            <div>
              <Radio.Group
                direction="hoz"
                value={goodsSelect}
                onChange={(value) => {
                  setGoodsSelect(value);
                }}
              >
                <Radio value={1}>默认TOP100</Radio>
                <Radio value={2}>
                  自定义选择商品
                  <span style={{ color: '#FF3333' }}>
                    (注:若筛选的商品未进入付款、浏览、加购商品用户数的TOP100，则无法获取相关商品效果数据，请知悉。)
                  </span>
                </Radio>
              </Radio.Group>
            </div>

            {/* 选择商品按钮 */}
            {goodsSelect === 2 ? (
              <div style={{ alignItems: 'flex-start' }}>
                <div className={`${styles['inline-block-item']}`} />
                <div
                  style={{
                    width: '100%',
                    padding: '20px 0px 20px 20px',
                    background: '#FFFFFF',
                    border: '1px solid #D7DDE4',
                  }}
                >
                  <Button
                    type="primary"
                    onClick={() => {
                      // failSku = 0;
                      // setImportSku([]);
                      // searchSku();
                      setGoodsDialog(true);
                    }}
                  >
                    选择商品
                  </Button>
                  <span style={{ marginLeft: '15px' }}>
                    已选择
                    <span style={{ color: '#FF3333' }}>
                      {selectGoods.length}
                    </span>
                    个
                  </span>
                </div>
              </div>
            ) : (
              <span />
            )}
          </div>}
        </div>
        <div className={styles.footer}>
          <Button
            type="normal"
            style={{ height: '30px', marginRight: '10px', width: 88 }}
            onClick={clearForm}
          >
            取消
          </Button>
          <Button
            type="primary"
            style={{ height: '30px' }}
            onClick={exportList}
          >
            确认导出
          </Button>
        </div>
      </div>
      <SelectGoods
        goodsDialog={goodsDialog}
        closeDialog={() => setGoodsDialog(false)}
        skuIds={skuIds}
        confirmSkuid={(v) => setSkuIds(v)}
        selectGoods={selectGoods}
        confirmGoods={(v) => setSelectGoods(v)}
      />
      {/* </div>
      </LzDialog> */}
      <Loading
        visible={isLoading}
        fullScreen
        // shape="fusion-reactor"
      />
    </div>
  );
};
